import { Themes } from '../shared/enums/enums'

export interface ThemeState {
  name: string
}

export interface UserState {
  username: string
  email: string
  activisionCode: string
}

export interface PageState {
  currentPage: string
}

export interface AppState {
  themeState: ThemeState
  userState: UserState
  pageState: PageState
}

// initializations
export const THEME_INITIAL_STATE: ThemeState = {
  name: Themes.LIGHT,
}

export const USER_INITIAL_STATE: UserState = {
  username: null,
  email: null,
  activisionCode: null,
}

export const PAGE_INITIAL_STATE: PageState = {
  currentPage: 'home',
}
